export const categories = [
  {
    id: 'cat-1',
    name: '设计素材',
    slug: 'design-resources',
    description: '免费图标、插画、字体、UI组件等设计相关资源',
    icon: 'ri-brush-line',
    resourceCount: 156,
    featured: true,
  },
  {
    id: 'cat-2',
    name: '图片视频',
    slug: 'image-video',
    description: '免费高清图片、视频素材、免版权图库资源',
    icon: 'ri-image-line',
    resourceCount: 98,
    featured: true,
  },
  {
    id: 'cat-3',
    name: '开发工具',
    slug: 'dev-tools',
    description: '免费API、开源框架、代码编辑器、开发辅助工具',
    icon: 'ri-code-s-slash-line',
    resourceCount: 203,
    featured: true,
  },
  {
    id: 'cat-4',
    name: '在线工具',
    slug: 'online-tools',
    description: '图片处理、格式转换、PDF工具等在线实用工具',
    icon: 'ri-tools-line',
    resourceCount: 145,
    featured: true,
  },
  {
    id: 'cat-5',
    name: '学习资源',
    slug: 'learning-resources',
    description: '免费课程、教程、电子书、学习平台等教育资源',
    icon: 'ri-book-open-line',
    resourceCount: 187,
    featured: true,
  },
  {
    id: 'cat-6',
    name: '字体下载',
    slug: 'fonts',
    description: '免费商用字体、中英文字体、创意字体下载',
    icon: 'ri-font-size',
    resourceCount: 72,
    featured: true,
  },
  {
    id: 'cat-7',
    name: '效率办公',
    slug: 'productivity',
    description: '免费笔记工具、项目管理、协作办公等效率提升资源',
    icon: 'ri-timer-line',
    resourceCount: 89,
    featured: false,
  },
  {
    id: 'cat-8',
    name: '影音娱乐',
    slug: 'entertainment',
    description: '免费音乐、播客、视频资源、音效素材等',
    icon: 'ri-music-line',
    resourceCount: 64,
    featured: false,
  },
  {
    id: 'cat-9',
    name: 'AI工具',
    slug: 'ai-tools',
    description: '免费AI写作、AI绘画、AI编程等人工智能工具合集',
    icon: 'ri-robot-line',
    resourceCount: 118,
    featured: true,
  },
  {
    id: 'cat-10',
    name: '建站资源',
    slug: 'website-building',
    description: '免费域名、主机、网站模板、建站工具等资源',
    icon: 'ri-global-line',
    resourceCount: 56,
    featured: false,
  },
  {
    id: 'cat-11',
    name: '营销推广',
    slug: 'marketing',
    description: '免费SEO工具、社交媒体管理、邮件营销等推广资源',
    icon: 'ri-megaphone-line',
    resourceCount: 73,
    featured: false,
  },
  {
    id: 'cat-12',
    name: '数据资源',
    slug: 'data-resources',
    description: '免费数据集、数据可视化工具、数据分析平台',
    icon: 'ri-bar-chart-line',
    resourceCount: 45,
    featured: false,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug);
};

export const getCategoryById = (id: string) => {
  return categories.find((c) => c.id === id);
};